import _ from 'lodash';
import { fetchCountries } from '@/shared/api';

/**
 * Loads the country list and shapes it for country select inputs. Maps each fetched country to a label from its name, a value from its alpha2 code and its dial code, logging the failure and returning an empty list when the request throws.
 *
 * @returns Promise resolving to the country option objects, or an empty array on failure.
 */
const handleFetchCountries = async () => {
  try {
    const countries = await fetchCountries();
    /**
     * Computes the select-option list from the fetched countries collection. Maps each country to an object of label (name), value (alpha2 code), and dial code.
     *
     * @returns Array of country option objects.
     */
    const formattedCountries = _.map(countries, (country) => ({
      label: country!.name,
      value: country!.alpha2,
      dial: country!.dial,
    }));
    return formattedCountries;
  } catch (error) {
    console.error('Failed to fetch countries: ', error);
    return [];
  }
};

export default handleFetchCountries;
